import React from "react";

const MyClientIcon = (props) => {
  return (
    <button
      className="MyClientIcon"
      title={props.title.toUpperCase()}
      onClick={() =>
        props.iconHandler({
          type: props.type,
          data: props.data,
          risk_profile: props.risk_profile,
          client_id: props.client_id,
          client_name: props.client_name,
        })
      }
    >
      {props.children}
    </button>
  );
};
export default MyClientIcon;



// WEBPACK FOOTER //
// ./src/components/pages/MyClients/myClientTable/MyClientIcon.jsx